import axios from 'axios';


const getSubscriptions = async(formdetails,page,records) =>{
    console.log("service")
    const formdata = {
        filters : formdetails,
        page : page,
        records : records
    }
    const response = await axios.post('/api/subscription-membership/get-subscriptions',formdata);
    return response.data;
}

const cancelSubscription = async (id) => {
   
    try {
        const response = await axios.post('/api/subscription-membership/cancel-subscription', { subscriptionId: id });
        console.log("cancel" , response.data)
        return response.data;
    } catch (error) {
        console.error("Error canceling subscription:", error);
        throw error;
    }
};
const changeStatus = async (id) => {
   
    try {
        
        const response = await axios.post('/api/subscription-membership/change-status',{ subscriptionId: id });
        console.log("change" , response.data)
        return response.data;
    } catch (error) {
        console.error("Error canceling subscription:", error);
        throw error;
    }
};

const getDetails = async (id) => {
    console.log(id)
    const response = await axios.get(`/api/subscription-membership/details/${id}`);
    console.log(response.data)
    return response.data;
}


const getAllPaymentGateways = async() =>{
    const response = await axios.get('/api/subscription-membership/get-payment-gateways');
    console.log(response.data)
    return response.data;
}


const getAllPlanId = async() =>{
    const response = await axios.get('/api/subscription-membership/get-plan-id');
    console.log(response.data)
    return response.data;
}
const getProjectPlans = async(projectId) =>{
    const response = await axios.get('/api/subscription-membership/get-project-plans',{
        params : { project_id : projectId }
    });
    return response.data;
}

const getUserActivePlan = async(projectId,userId) =>{
    const response = await axios.post('/api/subscription-membership/get-user-active-plan',{
        project_id : projectId,
        user_id : userId
    });
    return response.data;
}

const createComplementaryMembership = async(formdata) =>{
    const response = await axios.post('/api/subscription-membership/create-complementary-membership',formdata);
    return response.data;
}

export default {
    getSubscriptions,
    cancelSubscription,
    getAllPaymentGateways,
    getDetails,
    changeStatus,
    getAllPlanId,
    getProjectPlans,
    getUserActivePlan,
    createComplementaryMembership
}